(function () {
  if (window.NaomiKlaviyoFooterForm && window.NaomiKlaviyoFooterForm.initAll) {
    window.NaomiKlaviyoFooterForm.initAll();
    return;
  }

  var API_REVISION = "2026-07-15";
  var FORM_SELECTOR = "[data-naomi-klaviyo]";
  var PLACEHOLDER_PATTERN = /PASTE|REPLACE|YOUR|PUBLIC|LIST_ID|KEY_HERE/i;

  function cleanConfigValue(value) {
    var normalized = String(value || "").trim();
    return normalized && !PLACEHOLDER_PATTERN.test(normalized) ? normalized : "";
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
  }

  function updateEmailState(root, input) {
    root.classList.toggle("has-valid-email", isValidEmail(input && input.value));
  }

  function setMessage(root, message, state) {
    var messageNode = root.querySelector("[data-naomi-klaviyo-message]");

    if (!messageNode) return;

    messageNode.textContent = message || "";
    messageNode.hidden = !message;
    messageNode.classList.toggle("is-success", state === "success");
    messageNode.classList.toggle("is-error", state === "error");
  }

  function setBusy(root, isBusy) {
    var button = root.querySelector("[data-naomi-klaviyo-submit]");
    var input = root.querySelector("[data-naomi-klaviyo-email]");

    if (button) button.disabled = isBusy;
    if (input) input.setAttribute("aria-busy", isBusy ? "true" : "false");
  }

  function errorFromResponse(body, fallback) {
    if (!body || !Array.isArray(body.errors) || !body.errors.length) return fallback;

    return body.errors
      .map(function (error) {
        return error.detail || error.title;
      })
      .filter(Boolean)
      .join(" ");
  }

  function userFacingError(message) {
    var error = new Error(message);
    error.isUserFacing = true;
    return error;
  }

  function buildPayload(email, listId, source) {
    return {
      data: {
        type: "subscription",
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                properties: {
                  signup_source: source
                },
                subscriptions: {
                  email: {
                    marketing: {
                      consent: "SUBSCRIBED"
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId
            }
          }
        }
      }
    };
  }

  async function subscribe(root, email) {
    var publicKey = cleanConfigValue(root.dataset.klaviyoPublicKey);
    var listId = cleanConfigValue(root.dataset.klaviyoListId);
    var source = root.dataset.klaviyoSource || "Footer signup form";
    var response;
    var responseBody = null;

    if (!publicKey || !listId) {
      throw userFacingError("Signup is not configured yet.");
    }

    response = await fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + encodeURIComponent(publicKey), {
      method: "POST",
      headers: {
        "accept": "application/vnd.api+json",
        "content-type": "application/vnd.api+json",
        "revision": API_REVISION
      },
      body: JSON.stringify(buildPayload(email, listId, source))
    });

    try {
      responseBody = await response.json();
    } catch (error) {
      responseBody = null;
    }

    if (!response.ok) {
      throw userFacingError(errorFromResponse(responseBody, root.dataset.errorMessage || "Something went wrong. Please try again."));
    }
  }

  function init(root) {
    var form = root.querySelector("[data-naomi-klaviyo-form]");
    var input = root.querySelector("[data-naomi-klaviyo-email]");

    if (!form || !input || root.dataset.naomiKlaviyoReady === "true") return;

    root.dataset.naomiKlaviyoReady = "true";
    updateEmailState(root, input);

    input.addEventListener("input", function () {
      updateEmailState(root, input);
    });

    form.addEventListener("submit", async function (event) {
      var email = input.value.trim();

      event.preventDefault();
      updateEmailState(root, input);

      if (!isValidEmail(email)) {
        setMessage(root, "Please enter a valid email address.", "error");
        input.setAttribute("aria-invalid", "true");
        input.focus();
        return;
      }

      input.removeAttribute("aria-invalid");
      setMessage(root, "", "");
      setBusy(root, true);

      try {
        await subscribe(root, email);
        form.reset();
        updateEmailState(root, input);
        setMessage(root, root.dataset.successMessage || "Almost done. Check your inbox to confirm your signup.", "success");
      } catch (error) {
        setMessage(root, error && error.isUserFacing ? error.message : root.dataset.errorMessage, "error");
      } finally {
        setBusy(root, false);
      }
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll(FORM_SELECTOR), init);
  }

  window.NaomiKlaviyoFooterForm = {
    initAll: initAll
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
